import ArrowSquareDown from './ArrowSquareDown';

export default ArrowSquareDown;
